import React, { useState } from 'react';
import { Dropdown } from 'tea-component';
import './index.scss';
export default function DropdownBox({
  className,
  boxClassName,
  buttonElement,
  onClear,
  onClose,
  matchButtonWidth = true,
  ...otherProps
}: any) {
  const [openFlag, setOpenFlag] = useState(false);
  const toggleDropdown = (flag?: boolean) => {
    setOpenFlag(flag ?? !openFlag);
  };

  return (
    <Dropdown
      className={`dropdown-box-wrapper ${className}`}
      boxClassName={`dropdown-box-select ${boxClassName}`}
      button={<>{buttonElement(openFlag)}</>}
      size="auto"
      appearance="button"
      onClear={onClear}
      onClose={() => {
        toggleDropdown(false);
        onClose?.();
      }}
      // onOpen={() => toggleDropdown(true)}
      clickClose={false}
      matchButtonWidth={matchButtonWidth}
      {...otherProps}
    />
  );
}
